const KonferanseEventHeroBack = {
	init() {
		document.querySelectorAll('.konferanse-event-hero__back[data-back-fallback]').forEach((link) => {
			link.addEventListener('click', KonferanseEventHeroBack.handleClick);
		});
	},

	handleClick(event) {
		const link = event.currentTarget;
		const fallbackUrl = link.dataset.backFallback || link.getAttribute('href');

		if (!fallbackUrl) {
			return;
		}

		const currentUrl = KonferanseEventHeroBack.normalizeUrl(window.location.href);
		const referer = document.referrer;

		if (!referer || !KonferanseEventHeroBack.isSameOrigin(referer)) {
			return;
		}

		const refererUrl = KonferanseEventHeroBack.normalizeUrl(referer);

		if (!refererUrl || refererUrl === currentUrl) {
			return;
		}

		event.preventDefault();
		window.location.assign(referer);
	},

	isSameOrigin(url) {
		try {
			return new URL(url, window.location.origin).origin === window.location.origin;
		} catch {
			return false;
		}
	},

	normalizeUrl(url) {
		try {
			const parsed = new URL(url, window.location.origin);
			return `${parsed.origin}${parsed.pathname}${parsed.search}`;
		} catch {
			return null;
		}
	},
};

const markHeroImageHeader = () => {
	if (!document.querySelector('.block-section.konferanse-event-hero.has-image')) {
		return;
	}

	document.body.classList.add('konferanse-event-hero-has-image');
};

document.addEventListener('DOMContentLoaded', () => {
	KonferanseEventHeroBack.init();
	markHeroImageHeader();
});

export default KonferanseEventHeroBack;
